<template>
  <g>
    <text transform="matrix(1 0 0 1 150 60)" class="name">멀티미터{{number}}</text>
    <path class="st0" d="M727.89,348.86H154.45c-12.05,0-21.82-9.77-21.82-21.82V90.85c0-12.05,9.77-21.82,21.82-21.82h573.45
c12.05,0,21.82,9.77,21.82,21.82v236.2C749.71,339.09,739.94,348.86,727.89,348.86z" />
    <path class="st1" d="M720.47,329.47h-558.6c-5.32,0-9.64-4.32-9.64-9.64V98.06c0-5.32,4.32-9.64,9.64-9.64h558.6
c5.32,0,9.64,4.32,9.64,9.64v221.77C730.11,325.15,725.8,329.47,720.47,329.47z" />
    <g>
      <path class="st2" d="M162.29,325.18c-3.11,0-5.64-2.53-5.64-5.64V98.35c0-3.11,2.53-5.64,5.64-5.64h557.76
c3.11,0,5.64,2.53,5.64,5.64v221.18c0,3.11-2.53,5.64-5.64,5.64H162.29z" />
      <path class="st3"
        d="M720.05,93.71c2.56,0,4.64,2.08,4.64,4.64v221.19c0,2.56-2.08,4.64-4.64,4.64H162.29
c-2.56,0-4.64-2.08-4.64-4.64V98.35c0-2.56,2.08-4.64,4.64-4.64H720.05 M720.05,91.71H162.29c-3.66,0-6.64,2.98-6.64,6.64v221.19
c0,3.66,2.98,6.64,6.64,6.64h557.76c3.66,0,6.64-2.98,6.64-6.64V98.35C726.69,94.69,723.71,91.71,720.05,91.71L720.05,91.71z" />
    </g>
    <!-- POWER Button -->
    <circle
      @click="power()"
      :class="{'on' : on, 'st4': !on}"
      cx="197.13"
      cy="265.88"
      r="14.46" />
    <circle class="st5" cx="540.07" cy="266.82" r="38.8" />
    <circle class="st6" cx="540.07" cy="266.82" r="35.66" />
    <!-- Range Buttons -->
    <g>
      <!-- Range ▲ -->
      <g class="valid">
        <ellipse @click="setRange(1)" class="st8" cx="541.34" cy="243.5" rx="16.15" ry="7.05" />
        <polygon class="st9" points="541.34,239.55 535.83,247.06 546.85,247.06" />
      </g>
      <!-- Range ► -->
      <g class="valid">
        <ellipse class="st8" cx="563.39" cy="268.09" rx="7.05" ry="16.15" />
        <polygon class="st9" points="567.34,268.09 559.83,262.58 559.83,273.61" />
      </g>
       <!-- Range ▼ -->
      <g class="valid">
        <ellipse  @click="setRange(-1)" class="st8" cx="538.79" cy="290.14" rx="16.15" ry="7.05" />
        <polygon class="st9" points="538.79,294.09 544.3,286.58 533.28,286.58" />
      </g>
      <g class="valid">
        <ellipse class="st8" cx="516.75" cy="265.54" rx="7.05" ry="16.15" />
        <polygon class="st9" points="512.8,265.54 520.31,271.06 520.31,260.03" />
      </g>
    </g>
    <rect x="531.47" y="127.02" class="st10" width="29.83" height="51.57" />
    <g>
      <rect x="547.49" y="133.21" class="st6" width="9.83" height="15.13" />
      <rect x="549.6" y="135.57" class="st11" width="5.62" height="10.4" />
      <rect x="547.49" y="154.98" class="st6" width="9.83" height="16.7" />
      <rect x="549.6" y="157.13" class="st11" width="5.62" height="12.4" />
    </g>
    <!-- DCV Button -->
    <g @click="setFuncToggle('DCV')" class="valid">
      <path class="st6" d="M258.07,253c0,0-0.95,4.71-16.48,4.71S226.06,253,226.06,253v-14.75c0,0,1.32-3.22,15.61-3.22
c14.29,0,16.4,3.22,16.4,3.22V253z" />
      <path :class="{'st12': !functions.DCV.toggle, 'toggle': functions.DCV.toggle}" d="M255.48,251.59c0,0-0.8,3.71-13.82,3.71s-13.02-3.71-13.02-3.71v-11.63c0,0,1.11-2.54,13.09-2.54
s13.75,2.54,13.75,2.54V251.59z" />
      <text
        transform="matrix(1 0 0 1 233.4301 248.9685)"
        class="st13 st14">
        {{ functions.DCV.toggle || !functions.SHIFT.toogle ? 'DCV' : 'DCI' }}
      </text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 235.2172 230.6706)" class="st15 st16 st14">DCI</text>
    </g>
    <!-- ACV Button -->
    <g @click="setFuncToggle('ACV')" class="valid">
      <path class="st6" d="M297.43,253c0,0-0.95,4.71-16.48,4.71S265.42,253,265.42,253v-14.75c0,0,1.32-3.22,15.61-3.22
c14.29,0,16.4,3.22,16.4,3.22V253z" />
      <path :class="{'st12': !functions.ACV.toggle, 'toggle': functions.ACV.toggle}" d="M294.85,251.59c0,0-0.8,3.71-13.82,3.71c-13.02,0-13.02-3.71-13.02-3.71v-11.63c0,0,1.11-2.54,13.09-2.54
s13.75,2.54,13.75,2.54V251.59z" />
      <text transform="matrix(1 0 0 1 272.7938 248.9685)" class="st13 st14">ACV</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 274.5809 230.6706)" class="st15 st16 st14">ACI</text>
    </g>
    <!-- Ohm Button -->
    <g @click="setFuncToggle('OHM')" class="valid">
      <path class="st6" d="M336.8,253c0,0-0.95,4.71-16.48,4.71S304.78,253,304.78,253v-14.75c0,0,1.32-3.22,15.61-3.22
c14.29,0,16.4,3.22,16.4,3.22V253z" />
      <path :class="{'st12': !functions.OHM.toggle, 'toggle': functions.OHM.toggle}" d="M334.21,251.59c0,0-0.8,3.71-13.82,3.71c-13.02,0-13.02-3.71-13.02-3.71v-11.63c0,0,1.11-2.54,13.09-2.54
s13.75,2.54,13.75,2.54V251.59z" />
      <text transform="matrix(1 0 0 1 315.3985 250.1229)">
        <tspan x="0" y="0" class="st17 st14">Ω</tspan>
        <tspan x="6.26" y="0.07" class="st13 st14">2</tspan>
      </text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 315.3985 230.6218)">
        <tspan x="0" y="0" class="st15 st17 st14">Ω</tspan>
        <tspan x="6.26" y="0.1" class="st15 st16 st14">4</tspan>
      </text>
    </g>
    <g class="invalid">
      <path class="st6" d="M454.89,253c0,0-0.95,4.71-16.48,4.71S422.88,253,422.88,253v-14.75c0,0,1.32-3.22,15.61-3.22
c14.29,0,16.4,3.22,16.4,3.22V253z" />
      <path class="st12" d="M452.3,251.59c0,0-0.8,3.71-13.82,3.71s-13.02-3.71-13.02-3.71v-11.63c0,0,1.11-2.54,13.09-2.54
c11.98,0,13.75,2.54,13.75,2.54V251.59z" />
      <text transform="matrix(1 0 0 1 429 248.9685)" class="st13 st14">TEMP</text>
    </g>
    <g>
      <text transform="matrix(0.97 0 0 1 423.2992 230.6706)" class="st15 st16 st14">TCOUPL</text>
    </g>
    <g class="invalid">
      <path class="st6" d="M494.25,253c0,0-0.95,4.71-16.48,4.71S462.24,253,462.24,253v-14.75c0,0,1.32-3.22,15.61-3.22
c14.29,0,16.4,3.22,16.4,3.22V253z" />
      <path class="st12" d="M491.67,251.59c0,0-0.8,3.71-13.82,3.71s-13.02-3.71-13.02-3.71v-11.63c0,0,1.11-2.54,13.09-2.54
c11.98,0,13.75,2.54,13.75,2.54V251.59z" />
      <text transform="matrix(1 0 0 1 467 248.9685)" class="st13 st14">ENTER</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 470.1009 230.6706)" class="st15 st16 st14">2ND</text>
    </g>
    <g class="invalid">
      <path class="st6" d="M376.16,253c0,0-0.95,4.71-16.48,4.71S344.15,253,344.15,253v-14.75c0,0,1.32-3.22,15.61-3.22
c14.29,0,16.4,3.22,16.4,3.22V253z" />
      <path class="st12" d="M373.57,251.59c0,0-0.8,3.71-13.82,3.71s-13.02-3.71-13.02-3.71v-11.63c0,0,1.11-2.54,13.09-2.54
s13.75,2.54,13.75,2.54V251.59z" />
      <text transform="matrix(1 0 0 1 351 248.9685)" class="st13 st14">FERQ</text>
    </g>
    <g>
      <g>
        <line class="st18" x1="353.87" y1="227.19" x2="358.53" y2="227.19" />
        <line class="st18" x1="358.53" y1="224.04" x2="358.53" y2="230.26" />
      </g>
      <g>
        <line class="st18" x1="366.44" y1="227.11" x2="361.78" y2="227.11" />
        <line class="st18" x1="361.78" y1="230.26" x2="361.78" y2="224.04" />
      </g>
    </g>
    <g class="invalid">
      <path class="st6" d="M415.52,253c0,0-0.95,4.71-16.48,4.71S383.51,253,383.51,253v-14.75c0,0,1.32-3.22,15.61-3.22
c14.29,0,16.4,3.22,16.4,3.22V253z" />
      <path class="st12" d="M412.94,251.59c0,0-0.8,3.71-13.82,3.71s-13.02-3.71-13.02-3.71v-11.63c0,0,1.11-2.54,13.09-2.54
s13.75,2.54,13.75,2.54V251.59z" />
      <text transform="matrix(1 0 0 1 389.5 248.9685)" class="st13 st14">CONT</text>
    </g>
    <g>
      <g>
        <line class="st18" x1="393.23" y1="227.19" x2="397.89" y2="227.19" />
        <polygon class="st15" points="397.89,230.26 397.89,224.04 401.15,227.11" />
      </g>
      <g>
        <line class="st18" x1="405.81" y1="227.11" x2="401.15" y2="227.11" />
        <line class="st18" x1="401.15" y1="230.26" x2="401.15" y2="224.04" />
      </g>
    </g>
    <g class="invalid">
      <path class="st6" d="M258.23,292.19c0,0-0.95,4.71-16.48,4.71s-15.53-4.71-15.53-4.71v-14.75c0,0,1.32-3.22,15.61-3.22
c14.29,0,16.4,3.22,16.4,3.22V292.19z" />
      <path class="st12" d="M255.65,290.78c0,0-0.8,3.71-13.82,3.71s-13.02-3.71-13.02-3.71v-11.63c0,0,1.11-2.54,13.09-2.54
s13.75,2.54,13.75,2.54V290.78z" />
      <text transform="matrix(0.7 0 0 1 230.3175 288.16)" class="st13 st14">TRIGGER</text>
    </g>
    <g>
      <text transform="matrix(0.6 0 0 1 227.5553 269.8621)" class="st15 st16 st14">AUTO / HOLD</text>
    </g>
    <g class="invalid">
      <path class="st6" d="M297.43,292.19c0,0-0.95,4.71-16.48,4.71s-15.53-4.71-15.53-4.71v-14.75c0,0,1.32-3.22,15.61-3.22
c14.29,0,16.4,3.22,16.4,3.22V292.19z" />
      <path class="st12" d="M294.85,290.78c0,0-0.8,3.71-13.82,3.71c-13.02,0-13.02-3.71-13.02-3.71v-11.63c0,0,1.11-2.54,13.09-2.54
s13.75,2.54,13.75,2.54V290.78z" />
      <text transform="matrix(0.87 0 0 1 270.5 288.16)" class="st13 st14">STORE</text>
    </g>
    <g>
      <text transform="matrix(0.9 0 0 1 268.7619 269.8621)" class="st15 st16 st14">RECALL</text>
    </g>
    <g class="invalid">
      <path class="st6" d="M337.01,292.19c0,0-0.95,4.71-16.48,4.71s-15.53-4.71-15.53-4.71v-14.75c0,0,1.32-3.22,15.61-3.22
c14.29,0,16.4,3.22,16.4,3.22V292.19z" />
      <path class="st12" d="M334.42,290.78c0,0-0.8,3.71-13.82,3.71c-13.02,0-13.02-3.71-13.02-3.71v-11.63c0,0,1.11-2.54,13.09-2.54
s13.75,2.54,13.75,2.54V290.78z" />
      <text transform="matrix(0.96 0 0 1 311 288.1601)" class="st13 st14">DIGTS</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 308.2465 269.8621)" class="st15 st16 st14">FILTER</text>
    </g>
    <g class="invalid">
      <path class="st6" d="M454.82,292.19c0,0-0.95,4.71-16.48,4.71s-15.53-4.71-15.53-4.71v-14.75c0,0,1.32-3.22,15.61-3.22
c14.29,0,16.4,3.22,16.4,3.22V292.19z" />
      <path class="st19" d="M452.24,290.78c0,0-0.8,3.71-13.82,3.71s-13.02-3.71-13.02-3.71v-11.63c0,0,1.11-2.54,13.09-2.54
s13.75,2.54,13.75,2.54V290.78z" />
      <text transform="matrix(0.75 0 0 1 428.5 288.16)" class="st9 st13 st14">CONFIG</text>
    </g>
    <g>
      <text transform="matrix(0.97 0 0 1 427.4086 269.8621)" class="st15 st16 st14">MENU</text>
    </g>
    <g class="invalid">
      <path class="st6" d="M494.23,292.19c0,0-0.95,4.71-16.48,4.71s-15.53-4.71-15.53-4.71v-14.75c0,0,1.32-3.22,15.61-3.22
c14.29,0,16.4,3.22,16.4,3.22V292.19z" />
      <path class="st19" d="M491.64,290.78c0,0-0.8,3.71-13.82,3.71s-13.02-3.71-13.02-3.71v-11.63c0,0,1.11-2.54,13.09-2.54
s13.75,2.54,13.75,2.54V290.78z" />
      <text transform="matrix(1 0 0 1 471 288.16)" class="st9 st13 st14">ESC</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 467.1307 269.8621)" class="st15 st16 st14">AUTO</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 348.5612 269.8621)" class="st15 st16 st14">MATH</text>
    </g>
    <g class="invalid">
      <path class="st6" d="M375.5,292.19c0,0-0.95,4.71-16.48,4.71s-15.53-4.71-15.53-4.71v-14.75c0,0,1.32-3.22,15.61-3.22
s16.4,3.22,16.4,3.22V292.19z" />
      <path class="st12" d="M372.92,290.78c0,0-0.8,3.71-13.82,3.71c-13.02,0-13.02-3.71-13.02-3.71v-11.63c0,0,1.11-2.54,13.09-2.54
s13.75,2.54,13.75,2.54V290.78z" />
      <text transform="matrix(1 0 0 1 350 288.16)" class="st13 st14">NULL</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 386.5975 269.8621)" class="st15 st16 st14">LOCAL</text>
    </g>
    <!-- SHIFT Button -->
    <g @click="setFuncToggle('SHIFT', true)" class="valid">
      <path class="st6" d="M415.96,292.19c0,0-0.95,4.71-16.48,4.71s-15.53-4.71-15.53-4.71v-14.75c0,0,1.32-3.22,15.61-3.22c14.29,0,16.4,3.22,16.4,3.22V292.19z" />
      <path
        :class="{'st20': !functions.SHIFT.toggle, 'toggle': functions.SHIFT.toggle}"
        d="M413.37,290.78c0,0-0.8,3.71-13.82,3.71s-13.02-3.71-13.02-3.71v-11.63c0,0,1.11-2.54,13.09-2.54c11.98,0,13.75,2.54,13.75,2.54V290.78z" />
      <text transform="matrix(0.95 0 0 1 390.5 288.16)" class="st9 st13 st14">SHIFT</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 182.6741 246.3661)" class="st21 st22">POWER</text>
    </g>
    <g>
      <polygon points="193.17,290.11 193.17,286.13 188.85,286.13 188.85,290.11 186.8,290.11 186.8,291.4 195.22,291.4 195.22,290.11" />
      <polygon points="193.17,297.04 193.17,294.69 188.85,294.69 188.85,297.04 186.8,297.04 186.8,298.32 195.22,298.32 195.22,297.04" />
      <g>
        <text transform="matrix(1 0 0 1 200.3023 291.4014)">
          <tspan x="0" y="0" class="st16 st23">OFF</tspan>
          <tspan x="0" y="7" class="st16 st23">ON</tspan>
        </text>
      </g>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 523.3219 225.535)">
        <tspan x="0" y="0" class="st24 st25">RANGE</tspan>
        <tspan x="27.24" y="0.52" class="st24 st26">+</tspan>
      </text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 523.3219 314.2584)">
        <tspan x="0" y="0" class="st24 st25">RANGE</tspan>
        <tspan x="27.24" y="0.52" class="st24 st26">-</tspan>
      </text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 529.4719 121.7118)" class="st24 st25">TC INPUT</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 611.9973 122.2259)" class="st24 st25">SENSE</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 615.6075 176.864)">
        <tspan x="0" y="0" class="st24 st27">RATIO</tspan>
        <tspan x="0" y="6" class="st24 st27">REF</tspan>
      </text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 688.7462 176.864)">
        <tspan x="0" y="0" class="st24 st27">1000V</tspan>
        <tspan x="2.25" y="6" class="st24 st27">MAX</tspan>
      </text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 645.7603 198.6936)" class="st24 st25">LO</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 592.6713 176.8641)">
        <tspan x="0" y="0" class="st24 st27">200V</tspan>
        <tspan x="0.47" y="6" class="st24 st27">MAX</tspan>
      </text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 616.9932 281.6939)">
        <tspan x="0" y="0" class="st24 st27">FUSE</tspan>
        <tspan x="-4.73" y="6" class="st24 st27">3A 250V</tspan>
      </text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 667.2893 281.694)">
        <tspan x="0" y="0" class="st24 st27">FUSE</tspan>
        <tspan x="-6.5" y="6" class="st24 st27">15A 250V</tspan>
      </text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 637.6707 227.3514)">
        <tspan x="0" y="0" class="st24 st27">3A</tspan>
        <tspan x="-2.7" y="6" class="st24 st27">RMS</tspan>
      </text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 653.1516 227.3518)">
        <tspan x="0" y="0" class="st24 st27">10A</tspan>
        <tspan x="-0.93" y="6" class="st24 st27">RMS</tspan>
      </text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 687.0912 227.351)">
        <tspan x="0" y="0" class="st24 st27">500Vpk</tspan>
        <tspan x="3.9" y="6" class="st24 st27">MAX</tspan>
      </text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 560.0659 189.5637)">
        <tspan x="0" y="0" class="st24 st27">500Vpk</tspan>
        <tspan x="3.9" y="6" class="st24 st27">MAX</tspan>
      </text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 567.0434 150.3014)">
        <tspan x="0" y="0" class="st24 st27">5V</tspan>
        <tspan x="-3.07" y="6" class="st24 st27">MAX</tspan>
      </text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 693.0511 261.5822)" class="st24 st28">10A</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 596.7227 261.0299)" class="st24 st28">3A</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 646.0456 154.9787)" class="st29 st24 st25">HI</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 662.2846 122.2258)" class="st24 st25">INPUT</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 535.688 144.1266)">
        <tspan x="0" y="0" class="st24 st30">+</tspan>
        <tspan x="1.34" y="23" class="st24 st30">-</tspan>
      </text>
    </g>
    <text transform="matrix(1 0 0 1 616.6456 129.5521)" class="st24 st31">Ω4W</text>
    <g>
      <text transform="matrix(1 0 0 1 660.2678 129.5521)" class="st24 st31">VΩ</text>
      <g>
        <g>
          <rect x="670.33" y="127.3" width="3.05" height="0.49" />
          <rect x="673.13" y="125.49" width="0.49" height="4.06" />
        </g>
        <g>
          <rect x="675.51" y="127.25" width="3.05" height="0.49" />
          <rect x="675.26" y="125.49" width="0.49" height="4.06" />
        </g>
      </g>
      <g>
        <g>
          <rect x="680.43" y="127.3" width="3.05" height="0.49" />
          <polygon points="683.48,129.55 683.48,125.49 685.6,127.49" />
        </g>
        <g>
          <rect x="685.6" y="127.25" width="3.05" height="0.49" />
          <rect x="685.36" y="125.49" width="0.49" height="4.06" />
        </g>
      </g>
    </g>
    <g>
      <polygon class="st32" points="702.13,134.79 694.67,147.72 709.6,147.72" />
      <polygon class="st29" points="701.12,139.25 703.56,139.25 701.45,142.22 703.28,141.97 700.39,146.7 701.74,143.04 699.92,143.53" />
    </g>
    <g>
      <polygon class="st33" points="552.41,191.87 546.83,201.53 557.98,201.53" />
      <text transform="matrix(1 0 0 1 550.9049 200.4255)" class="st21 st34">!</text>
    </g>
    <g>
      <line class="st35" x1="570.89" y1="198.38" x2="570.89" y2="202.32" />
      <line class="st35" x1="567.16" y1="202.47" x2="574.62" y2="202.47" />
      <line class="st35" x1="568.7" y1="204.64" x2="573.09" y2="204.64" />
      <line class="st35" x1="569.82" y1="206.81" x2="571.96" y2="206.81" />
    </g>
    <path class="st35" d="M627.22,157.28h-24.95c-1.8,0-3.27,1.47-3.27,3.27v8.14" />
    <path class="st35" d="M671.96,202.47h-23.95c-1.8,0-3.27,1.47-3.27,3.27v14.14" />
    <path class="st35" d="M617.53,243.75h23.95c1.8,0,3.27-1.47,3.27-3.27v-4.89" />
    <path class="st35" d="M680.95,212.65H657c-1.8,0-3.27,1.47-3.27,3.27v3.95" />
    <path class="st35" d="M680.95,243.75H657c-1.8,0-3.27-1.47-3.27-3.27v-4.89" />
    <g>
      <g>
        <text transform="matrix(1 0 0 1 633.7581 305.9998)">
          <tspan x="0" y="0" class="st24 st36">CAT</tspan>
          <tspan x="11.73" y="0.17" class="st37 st36">II </tspan>
          <tspan x="18.38" y="0" class="st24 st36">600V</tspan>
        </text>
      </g>
      <g>
        <polygon class="st33" points="626.75,297.53 621.17,307.19 632.33,307.19" />
        <text transform="matrix(1 0 0 1 625.2468 306.0828)" class="st21 st34">!</text>
      </g>
      <g>
        <g>
          <line class="st35" x1="673.49" y1="306.45" x2="680.95" y2="306.45" />
          <line class="st35" x1="675.02" y1="308.62" x2="679.41" y2="308.62" />
          <line class="st35" x1="676.15" y1="310.79" x2="678.29" y2="310.79" />
        </g>
        <path class="st35" d="M670.07,303.22h5.75c0.77,0,1.41,0.63,1.41,1.41v1.82" />
      </g>
    </g>
    <path class="st35" d="M599,188.83v10.37c0,1.8,1.47,3.27,3.27,3.27h24.95" />
    <g>
      <path class="st35" d="M563.32,165.66h6.25c0.88,0,1.6-0.72,1.6-1.6v-4" />
      <path class="st35" d="M571.17,142.83v-4.09c0-0.88-0.72-1.6-1.6-1.6h-6.25" />
      <path class="st35" d="M571.17,180v-8.86c0-0.88-0.72-1.6-1.6-1.6h-6.25" />
    </g>
    <g>
      <path class="st35" d="M670.5,157.13h24.95c1.8,0,3.27,1.47,3.27,3.27v8.14" />
      <path class="st35" d="M698.71,188.68v10.37c0,1.8-1.47,3.27-3.27,3.27H670.5" />
    </g>
    <g>
      <line class="st35" x1="698.71" y1="235.64" x2="698.71" y2="239.58" />
      <line class="st35" x1="698.71" y1="248.19" x2="698.71" y2="253.62" />
      <line class="st38" x1="599" y1="248.19" x2="599" y2="253.62" />
      <line class="st35" x1="694.98" y1="239.72" x2="702.44" y2="239.72" />
      <line class="st35" x1="696.51" y1="241.89" x2="700.91" y2="241.89" />
      <line class="st35" x1="697.64" y1="244.06" x2="699.78" y2="244.06" />
    </g>
    <!-- Left Volt -->
    <g class="invalid">
      <radialGradient id="SVGID_2_" cx="624.1643" cy="151.3947" r="16.6089" gradientUnits="userSpaceOnUse">
        <stop offset="0.5647" style="stop-color:#500000" />
        <stop offset="0.6206" style="stop-color:#560000" />
        <stop offset="0.6953" style="stop-color:#670000" />
        <stop offset="0.7808" style="stop-color:#830000" />
        <stop offset="0.8702" style="stop-color:#A80000" />
      </radialGradient>
      <circle class="st39" cx="624.16" cy="151.39" r="16.61" />
      <circle
        class="st40 pin-cover terminal"
        cx="624.16"
        cy="151.39"
        r="8.16" />
    </g>
    <!-- Right Volt -->
    <g class="pin">
      <radialGradient id="SVGID_3_" cx="674.4605" cy="151.3947" r="16.6089" gradientUnits="userSpaceOnUse">
        <stop offset="0.5647" style="stop-color:#500000" />
        <stop offset="0.6206" style="stop-color:#560000" />
        <stop offset="0.6953" style="stop-color:#670000" />
        <stop offset="0.7808" style="stop-color:#830000" />
        <stop offset="0.8702" style="stop-color:#A80000" />
      </radialGradient>
      <circle class="st41" cx="674.46" cy="151.39" r="16.61" />
      <circle
        :id="`${pincode}VI`"
        @click="onClick(`${pincode}VI`)"
        class="st40 pin-cover terminal"
        cx="674.46"
        cy="151.39"
        r="8.16" />
    </g>
    <!-- Left Amper -->
    <g class="invalid">
      <radialGradient id="SVGID_4_" cx="624.1643" cy="203.1317" r="16.6089" gradientUnits="userSpaceOnUse">
        <stop offset="0.5647" style="stop-color:#121212" />
        <stop offset="0.6613" style="stop-color:#181818" />
        <stop offset="0.7903" style="stop-color:#292929" />
        <stop offset="0.8702" style="stop-color:#373737" />
      </radialGradient>
      <circle class="st42" cx="624.16" cy="203.13" r="16.61" />
      <radialGradient id="SVGID_5_" cx="624.1643" cy="203.1317" r="8.1614" gradientUnits="userSpaceOnUse">
        <stop offset="0.5647" style="stop-color:#121212" />
        <stop offset="0.7171" style="stop-color:#0C0C0C" />
        <stop offset="0.8702" style="stop-color:#000000" />
      </radialGradient>
      <circle
        class="st43 pin-cover terminal"
        cx="624.16"
        cy="203.13"
        r="8.16" />
    </g>
    <!-- Right Amper -->
    <g class="pin">
      <radialGradient id="SVGID_6_" cx="674.4605" cy="203.1317" r="16.6089" gradientUnits="userSpaceOnUse">
        <stop offset="0.5647" style="stop-color:#121212" />
        <stop offset="0.6613" style="stop-color:#181818" />
        <stop offset="0.7903" style="stop-color:#292929" />
        <stop offset="0.8702" style="stop-color:#373737" />
      </radialGradient>
      <circle class="st44" cx="674.46" cy="203.13" r="16.61" />
      <radialGradient id="SVGID_7_" cx="674.4605" cy="203.1317" r="8.1614" gradientUnits="userSpaceOnUse">
        <stop offset="0.5647" style="stop-color:#121212" />
        <stop offset="0.7171" style="stop-color:#0C0C0C" />
        <stop offset="0.8702" style="stop-color:#000000" />
      </radialGradient>
      <circle
        :id="`${pincode}CM`"
        @click="onClick(`${pincode}CM`)"
        class="st45 pin-cover terminal"
        cx="674.46"
        cy="203.13"
        r="8.16" />
    </g>
    <!-- Left GND -->
    <g class="invalid">
      <g>
        <radialGradient id="SVGID_8_" cx="624.1643" cy="254.8685" r="15.6089" gradientUnits="userSpaceOnUse">
          <stop offset="0" style="stop-color:#5F4E1B" />
          <stop offset="0.1933" style="stop-color:#62501C" />
          <stop offset="0.3481" style="stop-color:#6C581F" />
          <stop offset="0.4896" style="stop-color:#7D6523" />
          <stop offset="0.6231" style="stop-color:#95772A" />
          <stop offset="0.7511" style="stop-color:#B38E32" />
          <stop offset="0.8732" style="stop-color:#D9AB3C" />
          <stop offset="0.8862" style="stop-color:#DDAE3D" />
        </radialGradient>
        <path class="st46" d="M624.16,270.48c-8.61,0-15.61-7-15.61-15.61c0-8.61,7-15.61,15.61-15.61c8.61,0,15.61,7,15.61,15.61 C639.77,263.48,632.77,270.48,624.16,270.48z" />
        <g>
          <path class="st47" d="M624.16,240.26c8.06,0,14.61,6.55,14.61,14.61s-6.55,14.61-14.61,14.61s-14.61-6.55-14.61-14.61 S616.11,240.26,624.16,240.26 M624.16,238.26c-9.17,0-16.61,7.44-16.61,16.61s7.44,16.61,16.61,16.61s16.61-7.44,16.61-16.61 S633.34,238.26,624.16,238.26L624.16,238.26z" />
        </g>
      </g>
      <circle
        class="st48 pin-cover terminal"
        cx="624.16"
        cy="254.87"
        r="8.16" />
    </g>
    <!-- Right GND -->
    <g class="pin">
      <g>
        <radialGradient id="SVGID_9_" cx="674.4602" cy="254.8685" r="15.6089" gradientUnits="userSpaceOnUse">
          <stop offset="0" style="stop-color:#5F4E1B" />
          <stop offset="0.1933" style="stop-color:#62501C" />
          <stop offset="0.3481" style="stop-color:#6C581F" />
          <stop offset="0.4896" style="stop-color:#7D6523" />
          <stop offset="0.6231" style="stop-color:#95772A" />
          <stop offset="0.7511" style="stop-color:#B38E32" />
          <stop offset="0.8732" style="stop-color:#D9AB3C" />
          <stop offset="0.8862" style="stop-color:#DDAE3D" />
        </radialGradient>
        <path class="st49" d="M674.46,270.48c-8.61,0-15.61-7-15.61-15.61c0-8.61,7-15.61,15.61-15.61c8.61,0,15.61,7,15.61,15.61C690.07,263.48,683.07,270.48,674.46,270.48z" />
        <path class="st47" d="M674.46,240.26c8.06,0,14.61,6.55,14.61,14.61s-6.55,14.61-14.61,14.61s-14.61-6.55-14.61-14.61S666.41,240.26,674.46,240.26 M674.46,238.26c-9.17,0-16.61,7.44-16.61,16.61s7.44,16.61,16.61,16.61c9.17,0,16.61-7.44,16.61-16.61S683.63,238.26,674.46,238.26L674.46,238.26z" />
      </g>
      <circle
        :id="`${pincode}MA`"
        @click="onClick(`${pincode}MA`)"
        class="st48 pin-cover terminal"
        cx="674.46"
        cy="254.87"
        r="8.16" />
    </g>
    <g>
      <defs>
        <path id="SVGID_10_" d="M720.05,324.18H162.29c-2.56,0-4.64-2.08-4.64-4.64V98.35c0-2.56,2.08-4.64,4.64-4.64h557.76
c2.56,0,4.64,2.08,4.64,4.64v221.19C724.69,322.1,722.61,324.18,720.05,324.18z" />
      </defs>
      <clipPath id="SVGID_11_">
        <use xlink:href="#SVGID_10_" style="overflow:visible;" />
      </clipPath>
      <path class="st50" d="M727.67,92.94H502.69c-0.78,0-1.42,0.63-1.42,1.42v9.42c0,0.78,0.63,1.42,1.42,1.42h224.99
c0.78,0,1.42-0.63,1.42-1.42v-9.42C729.09,93.57,728.45,92.94,727.67,92.94z" />
      <path class="st51" d="M507.84,132.77H215.97c-0.81,0-1.47-0.66-1.47-1.47v-39.1c0-0.81,0.66-1.47,1.47-1.47h291.87
c0.81,0,1.47,0.66,1.47,1.47v39.1C509.31,132.1,508.65,132.77,507.84,132.77z" />
      <path class="st52" d="M501.89,111.83H221.92c-1.45,0-2.63-1.18-2.63-2.63v-9.29c0-1.45,1.18-2.63,2.63-2.63h279.97
c1.45,0,2.63,1.18,2.63,2.63v9.29C504.52,110.65,503.34,111.83,501.89,111.83z" />
    </g>
    <g>
      <g>
        <path class="st53" d="M500.8,213.96H223.01c-4.7,0-8.51-3.81-8.51-8.51v-80c0-4.7,3.81-8.51,8.51-8.51H500.8
c4.7,0,8.51,3.81,8.51,8.51v80C509.31,210.15,505.5,213.96,500.8,213.96z" />
        <!-- Display Pannel -->
        <path style="transform: scale(1.3) translate(-84px, -38px);" class="st54" d="M465.34,191.65H258.48c-0.36,0-0.65-0.29-0.65-0.65v-51.1c0-0.36,0.29-0.65,0.65-0.65h206.86
c0.36,0,0.65,0.29,0.65,0.65V191C465.99,191.36,465.7,191.65,465.34,191.65z" />
        <!-- Display value -->
        <g v-if="on" class="display">
          <text :transform="textPosition"> {{ measuredInfo.value }} </text>
          <g v-if="!error.is">
            <text transform="matrix(1 0 0 1 390 165)"> {{ info.unit }} </text>
            <text class="type" transform="matrix(1 0 0 1 440 165)"> {{ info.type }} </text>
          </g>
          <g transform="matrix(1 0 0 1 260 190)">
            <text class="range"> {{ rangeText }}</text>
          </g>
        </g>
      </g>
      <g>
        <rect x="215.48" y="152.52" class="st55" width="4.46" height="24.34" />
        <rect x="215.48" y="140.43" class="st55" width="4.46" height="4.77" />
        <rect x="215.48" y="185.49" class="st55" width="4.46" height="4.77" />
      </g>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 302.093 106.9046)" class="st16 st56">DIGIT MULTIMETER</text>
    </g>
    <g>
      <text transform="matrix(1 0 0 1 261.9021 106.9046)" class="st16 st56">2110 5 1/2 </text>
    </g>

    <g>
      <rect x="223.75" y="99.83" class="st57" width="35.62" height="8.94" />
      <text transform="matrix(1 0 0 1 224.6355 106.9046)" class="st9 st16 st56">KEITHLEY</text>
    </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'
/*
  아래의 멀티미터 측정 범위(Measurement ranges)는
  'KEITHLEY 2110 5 1/2' 멀티미터 모델의 데이터 시트에 따른다.
*/
const DC_VOLT_RANGES = [
  { val: 100, unit: 'mV', scale: 0.001 },
  { val: 1, unit: 'V', scale: 1 }, // default
  { val: 10, unit: 'V', scale: 1 },
  { val: 100, unit: 'V', scale: 1 },
  { val: 1000, unit: 'V', scale: 1 }
]
const DC_CURR_RANGES = [
  { val: 10, unit: 'µA', scale: 0.000001 },
  { val: 100, unit: 'µA', scale: 0.000001 },
  { val: 1, unit: 'mA', scale: 0.001 },
  { val: 10, unit: 'mA', scale: 0.001 },
  { val: 100, unit: 'mA', scale: 0.001 },
  { val: 1, unit: 'A', scale: 1 }, // default
  { val: 3, unit: 'A', scale: 1 },
  { val: 10, unit: 'A', scale: 1 }
]
const DC_OHM_RANGES = [
  { val: 100, unit: 'Ω', scale: 1 }, // default
  { val: 1, unit: 'kΩ', scale: 1000 },
  { val: 10, unit: 'kΩ', scale: 10000 },
  { val: 100, unit: 'kΩ', scale: 100000 },
  { val: 1, unit: 'MΩ', scale: 1000000 }
]

// const OVERFLOW_MSG = 'OVERFLOW'
// const UNDERFLOW_MSG = 'UNDERFLOW'
const NOT_MATCH_MSG = 'NOT MATCH'
const NO_VALUE_MSG = 'NO VALUE'
const NOT_SELECT_MODE_MSG = 'NOT SELECT MODE'
// const DISPLAY_DIGIT_LIMIT = 7

const increaseRangePtr = function (ptr, ranges, increase) {
  if (ptr + increase > -1 && ptr + increase < ranges.length) return ptr + increase
  return ptr
}

const paddingZeros = function (value) {
  return (value * 1.0).toFixed(3).toString()
}

export default {
  props: ['data'],
  mixins: [pins],
  data () {
    return {
      code: '',
      on: false,
      timemax: null,
      measures: { // measured values after simulation
        volt: 0, // '-999999' means 'No Value'
        amper: 0,
        resist: 0,
        unit: 'AE'
      },
      info: {
        value: '000.000',
        unit: '',
        type: '', // two types : DC, AC
        mode: null // three modes : Volt, Amper, Ohm
      },
      range: {
        value: 1, // limitation of range
        vptr: 1, // volt pointer (default 1)
        cptr: 5, // current pointer (default 4)
        optr: 0 // ohm potiner (default 0)
      },
      func: '', // DCV, DCI, ACV, ACI, OHM
      functions: {
        DCV: { toggle: false },
        DCI: { toggle: false },
        SHIFT: { toggle: false },
        ACV: { toggle: false },
        OHM: { toggle: false }
      },
      activateFuns: 0, // the number of acitvated functions
      error: {
        is: false,
        msg: 'Error! Please try again'
      }
    }
  },
  mounted () {
    this.setPindata(this.data)
    this.code = this.namecode
  },
  computed: {
    textPosition () {
      if (this.error.is) return 'matrix(1 0 0 1 280 165)'
      else if (!this.info.mode) return `matrix(1 0 0 1 ${450 - 20 * this.info.value.length} 165)`
      else return `matrix(1 0 0 1 ${410 - 20 * this.info.value.length} 165)`
    },
    rangeText () {
      if (this.error.is) return this.error.msg
      else if (!this.info.mode) return NOT_SELECT_MODE_MSG
      else return `RANGE : ${this.range.value}${this.info.unit} ${this.info.type}`
    },
    isDCIMode () {
      return this.functions.DCV.toggle && this.functions.SHIFT.toggle
    },
    measuredInfo () {
      if (!this.on || this.func === '') return this.info
      this.setInfoValue()
      return this.info
    }
  },
  methods: {
    onClick (pin) {
      window.event.stopPropagation()
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
    },
    power () {
      window.event.stopPropagation()
      this.on = !this.on
    },
    setError (isError) {
      this.error.is = isError
    },
    setRange (increase) {
      window.event.stopPropagation()
      if (!this.info.mode) return
      let ranges = []
      let ptr = null
      switch (this.info.mode) {
        case 'Volt' :
          ranges = DC_VOLT_RANGES
          this.range.vptr = increaseRangePtr(this.range.vptr, ranges, increase)
          ptr = this.range.vptr
          break
        case 'Amper' :
          ranges = DC_CURR_RANGES
          this.range.cptr = increaseRangePtr(this.range.cptr, ranges, increase)
          ptr = this.range.cptr
          break
        case 'Ohm' :
          ranges = DC_OHM_RANGES
          this.range.optr = increaseRangePtr(this.range.optr, ranges, increase)
          ptr = this.range.optr
          break
      }
      this.info.unit = ranges[ptr].unit
      this.range.value = ranges[ptr].val
      this.setDisplayValueByMode()
    },
    setInfo (mode, unit, type) {
      this.info.mode = mode
      this.info.unit = unit
      this.info.type = type
    },
    setInfoValue () {
      this.info.value = this.getMeasuredValue(this.func)
      this.error.is = this.info.value === NOT_MATCH_MSG
      this.setDisplayInfo(this.func)
    },
    setDisplayValueByMode () {
      switch (this.info.mode) {
        case 'Volt':
          this.setDisplayValue(this.measures.volt, DC_VOLT_RANGES[this.range.vptr])
          break
        case 'Amper':
          this.setDisplayValue(this.measures.amper, DC_CURR_RANGES[this.range.cptr])
          break
        case 'Ohm':
          this.setDisplayValue(this.measures.resist, DC_OHM_RANGES[this.range.optr])
          break
      }
    },
    setDisplayValue (value, unit) {
      this.error.is = false
      this.info.value = paddingZeros(value / unit)
    },
    setDisplayInfo (func) {
      switch (func) {
        case 'DCV' :
          this.setInfo('Volt', 'V', 'DC')
          break
        case 'ACV' :
          this.setInfo('Volt', 'V', 'AC')
          break
        case 'DCI' :
          this.setInfo('Amper', 'A', 'DC')
          break
        case 'ACI' :
          this.setInfo('Amper', 'A', 'AC')
          break
        case 'OHM' :
          this.setInfo('Ohm', 'Ω', 'DC')
          break
        default:
          this.setInfo(null, '', '')
      }
    },
    getFuncWithShfit () {
      if (this.activateFuns === 2) {
        if (this.functions.DCV.toggle) return 'DCI'
        else if (this.functions.ACV.toggle) return 'ACI'
        else if (this.functions.OHM.toggle) return 'OHM'
      } else if (this.activateFuns === 1) {
        return this.findOneToggleOnBykey()
      } else return ''
    },
    getMeasuredValue (func) {
      if (!this.measures) return NO_VALUE_MSG
      let val = 0
      switch (func) {
        case 'DCV':
          val = this.measures.unit === 'VE'
            ? paddingZeros(this.measures.volt) : NOT_MATCH_MSG
          break
        case 'DCI':
          val = this.measures.unit === 'AE'
            ? paddingZeros(this.measures.amper) : NOT_MATCH_MSG
          break
        case 'ACV':
          val = this.measures.unit === 'VA'
            ? paddingZeros(this.measures.volt) : NOT_MATCH_MSG
          break
        case 'ACI':
          val = this.measures.unit === 'AA'
            ? paddingZeros(this.measures.amper) : NOT_MATCH_MSG
          break
        case 'OHM':
          val = paddingZeros(this.measures.resist)
          break
        default:
          val = '000.000'
      }
      return val
    },
    setFuncToggle (func) {
      window.event.stopPropagation()
      if (!this.on) return
      this.error.is = false
      this.functions[func].toggle = !this.functions[func].toggle
      this.activateFuns += this.functions[func].toggle ? 1 : -1
      if (this.functions.SHIFT.toggle) {
        if (this.activateFuns <= 2) func = this.getFuncWithShfit()
        else this.info.value = NOT_MATCH_MSG
      } else if (!this.functions.SHIFT.toggle) {
        if (this.activateFuns === 2) this.setOneToggleOn(func)
        else if (this.activateFuns === 1) func = this.findOneToggleOnBykey()
        else func = ''
      }
      this.func = func
      this.setInfoValue()
      this.setDisplayInfo(this.func)
    },
    setOneToggleOn (func) {
      Object.keys(this.functions).forEach(key => {
        this.functions[key].toggle = false
      })
      this.functions[func].toggle = true
      this.activateFuns = 1
    },
    findOneToggleOnBykey () {
      return Object.keys(this.functions).filter(key => this.functions[key].toggle)[0]
    },
    start (socket) {
      // console.log('MT start ', socket.url)
      // console.log('MT start ', socket)
      this.on = true
      socket.onmessage = ({ data }) => {
        // console.log("multimeter socket message:", data)
        // {"value": 0.386, "type": "VE"}
        data = JSON.parse(data)
        // console.log(data)
        this.measures.unit = data.type
        this.measures.volt = data.value.volt
        this.measures.amper = data.value.amper
        this.measures.resist = data.value.volt / data.value.amper
        this.setInfoValue()
      }
    },
    off () {}
  }
}
</script>

<style lang="scss" scoped>
g.selected {
  path.st0{
    stroke-width: 3px;
    stroke: #ff6f61;
  }
}
.pin-cover {
    display: block;
    stroke: none;
    fill: black;
    // fill: #887BB0;
}
.pin:hover {
  .pin-cover {
    cursor: pointer;
    stroke-width: 1px;
    stroke: black;
    fill: #ff6f61;
  }
  .disable {
    cursor: not-allowed;
  }
}
.on {
  fill: #ff6f61;
  stroke:#231815;
  stroke-width:0.5;
}
.toggle {
  fill: #ff6f61;
  font-weight: bold;
}
.toggle:hover,.valid:hover {
  cursor: pointer;
}
.invalid:hover {
  cursor: not-allowed;
}
g.display {
  text{
    fill: #248D3A;
    font-size: 30px;
  }
  text.type {
    font-size: 25px;
    font-style: italic;
  }
  text.range {
     font-size: 22px;
    font-style: italic;
  }
}

.highlight {
  -webkit-filter: drop-shadow( 0px 0px 5px rgba(0, 0, 255, 0.7));
  filter: drop-shadow( 0px 0px 5px rgba(0, 0, 255, 0.7));
}

  .st0 {
    fill: #73787A;
  }

  .st1 {
    fill: #5C6264;
  }

  .st2 {
    fill: #D2D2D1;
  }

  .st3 {
    fill: #9A9A96;
  }

  .st4 {
    fill: #EEEEEF;
    stroke: black;
    &:hover {
      cursor: pointer;
    }
  }

  .st5 {
    fill: #E1E1E0;
    stroke: #ADADAC;
    stroke-width: 0.5;
    stroke-miterlimit: 10;
  }

  .st6 {
    fill: #D2D2D1;
    stroke: #ADADAC;
    stroke-width: 0.5;
    stroke-miterlimit: 10;
  }

  .st7 {
    fill: url(#SVGID_1_);
  }

  .st8 {
    fill: #696969;
  }
  .st9 {
    fill: #FFFFFF;
  }

  .st10 {
    fill: #73797E;
    stroke: #000000;
    stroke-miterlimit: 10;
  }

  .st11 {
    stroke: #ADADAC;
    stroke-miterlimit: 10;
  }

  .st12 {
    fill: #E8E4CC;
    stroke: #B5B5B4;
    stroke-width: 0.5;
    stroke-miterlimit: 10;
  }

  .st13 {
    font-family: 'Helvetica75-Bold';
  }

  .st14 {
    font-size: 8.1443px;
  }

  .st15 {
    fill: #124071;
  }

  .st16 {
    font-family: 'Helvetica-Light';
  }

  .st17 {
    font-family: 'ScriptMTBold';
  }

  .st18 {
    fill: none;
    stroke: #124071;
    stroke-width: 0.75;
    stroke-miterlimit: 10;
  }

  .st19 {
    fill: #696969;
    stroke: #424242;
    stroke-width: 0.5;
    stroke-miterlimit: 10;
  }

  .st20 {
    fill: #2048FF;
    stroke: #ADADAC;
    stroke-width: 0.5;
    stroke-miterlimit: 10;
  }

  .st21 {
    font-family: 'Calibri-Bold';
  }

  .st22 {
    font-size: 8.2548px;
  }

  .st23 {
    font-size: 5px;
  }

  .st24 {
    font-family: 'Calibri';
  }

  .st25 {
    font-size: 8.4179px;
  }

  .st26 {
    font-size: 11px;
  }

  .st27 {
    font-size: 7px;
  }

  .st28 {
    font-size: 6px;
  }

  .st29 {
    fill: #B10000;
  }

  .st30 {
    font-size: 14px;
  }

  .st31 {
    font-size: 6.623px;
  }

  .st32 {
    fill: none;
    stroke: #B10000;
    stroke-width: 0.5;
    stroke-miterlimit: 10;
  }

  .st33 {
    fill: none;
    stroke: #000000;
    stroke-width: 0.5;
    stroke-miterlimit: 10;
  }

  .st34 {
    font-size: 7.8262px;
  }

  .st35 {
    fill: none;
    stroke: #000000;
    stroke-miterlimit: 10;
  }

  .st36 {
    font-size: 7.3364px;
  }

  .st37 {
    font-family: 'GoudyOldStyleT-Regular';
  }

  .st38 {
    fill: none;
    stroke: #B10000;
    stroke-miterlimit: 10;
  }

  .st39 {
    fill: url(#SVGID_2_);
  }

  .st40 {
    stroke: #910000;
    stroke-width: 2;
    stroke-miterlimit: 10;
  }

  .st41 {
    fill: url(#SVGID_3_);
  }

  .st42 {
    fill: url(#SVGID_4_);
  }

  .st43 {
    fill: url(#SVGID_5_);
    stroke: #2C2C2C;
    stroke-width: 2;
    stroke-miterlimit: 10;
  }

  .st44 {
    fill: url(#SVGID_6_);
  }

  .st45 {
    fill: url(#SVGID_7_);
    stroke: #2C2C2C;
    stroke-width: 2;
    stroke-miterlimit: 10;
  }

  .st46 {
    fill: url(#SVGID_8_);
  }

  .st47 {
    fill: #FFE39B;
  }

  .st48 {
    stroke: #FFE39B;
    stroke-width: 2;
    stroke-miterlimit: 10;
  }

  .st49 {
    fill: url(#SVGID_9_);
  }

  .st50 {
    clip-path: url(#SVGID_11_);
    fill: #C00000;
  }

  .st51 {
    clip-path: url(#SVGID_11_);
    fill: #D2D2D1;
    stroke: #ADADAC;
    stroke-width: 2;
    stroke-miterlimit: 10;
  }

  .st52 {
    clip-path: url(#SVGID_11_);
    fill: #D2D2D1;
    stroke: #ADADAC;
    stroke-miterlimit: 10;
  }

  .st53 {
    fill: #555D63;
    stroke: #292524;
    stroke-width: 2;
    stroke-miterlimit: 10;
  }

  .st54 {
    fill: #0E1E28;
  }

  .st55 {
    fill: #767C81;
  }

  .st56 {
    font-size: 7.3418px;
  }

  .st57 {
    fill: #D10000;
  }
</style>
